import { Select } from 'antd';
import { forwardRef, useRef, useState } from 'react';

import AngleDown from '../../../assets/AngleDown';
import { useMeasure } from '../../../utils/hooks/useMeasure/useMeasure';
import styles from './AppSelect1.module.scss';

const AppSelect1 = forwardRef((props, ref) => {
  const { dropdownPopupRootClassName = '', className = '', children, ...restProps } = props;
  const rootRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const { width: rootRefWidth, left: rootRefLeft } = useMeasure(rootRef);

  const SelectComponent = (
    <Select
      ref={ref}
      variant='borderless'
      className={`${styles.selectComponent} ${className}`}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      classNames={{
        popup: {
          root: dropdownPopupRootClassName,
        },
      }}
      styles={{
        popup: {
          root: {
            width: rootRefWidth,
            left: rootRefLeft,
          },
        },
      }}
      placement='topLeft'
      suffixIcon={<AngleDown />}
      {...restProps}
    />
  );

  return (
    <div className={`${styles.appSelect1} ${isFocused ? styles.focused : ''}`} ref={rootRef}>
      {children({ SelectComponent })}
    </div>
  );
});

AppSelect1.displayName = 'AppSelect1';

export default AppSelect1;
